import React, { useState } from "react";

interface ImageWithFallbackProps {
  src: string | undefined;
  alt: string | undefined;
  fallbackSrc: string | undefined;
  style?: React.CSSProperties;
}

const ImageWithFallback = (props: ImageWithFallbackProps) => {
  const [imgSrc, setImgSrc] = useState(props.src);

  const handleError = () => {
    setImgSrc(props.fallbackSrc);
  };

  return <img style={props.style} src={imgSrc || props.fallbackSrc} alt={props.alt} onError={handleError} />;
};

export default ImageWithFallback;
